import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export interface CasteCount {
  casteName: string;
  boysCount: number;
  girlCount: number;
  totalCount: number;
}

export interface EnrollmentResponseDto {
  schoolId: number;
  totalStudents: number;
  vocationalSubjects: number;
  otherSubjects: number;
  className: string;
  session: string;
  medium: string;
  subjects: Record<string, number>;
  casteList: CasteCount[];
}

export interface EnrollmentRequestDto {
  schoolId: number;
  classId?: number;
  className: string;
  sessionId: number;
  medium: string;
}

const API_URL = `${process.env.REACT_APP_API_URL}/enrollment`;

export function useEnrollment() {
  const enrollmentMutation = useMutation<EnrollmentResponseDto, Error, EnrollmentRequestDto>({
    mutationFn: async (data: EnrollmentRequestDto) => {
      const response = await axios.post(API_URL, data);
      return response.data;
    }
  });

  return { enrollmentMutation };
}
